import { render, staticRenderFns } from "./FoodCard.vue?vue&type=template&id=1d8984d2&scoped=true&"
import script from "./FoodCard.vue?vue&type=script&lang=js&"
export * from "./FoodCard.vue?vue&type=script&lang=js&"
import style0 from "./FoodCard.vue?vue&type=style&index=0&id=1d8984d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8984d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
